import { Grid } from '@material-ui/core';
import { css } from '@emotion/css';
import PropTypes from 'prop-types';
import {
  ChevronRight,
  Send,
  Search,
  Group,
  CheckCircle,
  Cancel,
  TuneRounded as Tune,
} from '@material-ui/icons';
import { useStyles } from '@webapps/styles';

const KPITeam = ({ data }) => {
  const {
    theme: { spacing },
  } = useStyles();

  return (
    <Grid
      className={css({
        backgroundColor: '#ffffff',
        display: 'flex',
        marginBottom: "30px",
        color: '#152652',
        fontFamily: 'Montserrat',
        borderRadius: '10px',
        '@media screen and (max-width: 768px)': {
          height: '100%',
          backgroundColor: 'unset',
          borderRadius: 'unset',
          flexDirection: 'column',
        },
      })}
      container
    >
      {data.slice(0, 4).map(({ value, icon: IconComponent }, index) => (
        <div
          key={index}
          className={css({
            fontWeight: 600,
            fontSize: '18px',
            lineHeight: '110%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            borderRight: index < data.length - 1 ? '1px solid #C1D9FF' : 'none',
            width: '25%',
            padding: '20px',
            '@media only screen and (max-width: 768px)': {
              width: '100%',
              borderRight: 'none',
              backgroundColor: 'white',
              borderRadius: '5px',
              flexDirection: 'row',
              alignItems: 'center',
            },
          })}
        >
          <div className={css({ display: 'flex', alignItems: 'center' })}>
            {IconComponent && <IconComponent className={css({ color: '#0060F9', marginRight: 10 })} />}
            <span>{value}</span>
          </div>
        </div>
      ))}
    </Grid>
  );
};

KPITeam.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      icon: PropTypes.elementType, // Accepts MUI icons as components
    })
  ).isRequired,
};

export default KPITeam;
